import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import { AgeGate } from "./components/AgeGate";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { SmoothScroll } from "./components/SmoothScroll";
import Home from "./pages/Home";
import Browse from "./pages/Browse";
import Watch from "./pages/Watch";
import Legal from "./pages/Legal";
import Admin from "./pages/Admin";
import AdminLogin from "./pages/AdminLogin";
import AuthCallback from "./pages/AuthCallback";
import { AdsProvider, AdSlot, Popunders, MobileSticky } from "./components/Ads";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <>
      <ScrollTop />
      <Header />
      {!isAdmin && <Popunders />}
      {!isAdmin && <AdSlot placement="top" className="px-5 pt-24" />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/videos" element={<Browse key="v" mode="video" />} />
          <Route path="/fotos" element={<Browse key="p" mode="photo" />} />
          <Route path="/em-alta" element={<Browse key="t" mode="trending" />} />
          <Route path="/mais-curtidos" element={<Browse key="l" mode="liked" />} />
          <Route path="/video/:id" element={<Watch />} />
          <Route path="/legal/:slug" element={<Legal />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      {!isAdmin && <MobileSticky />}
    </>
  );
}

function App() {
  return (
    <div className="grain min-h-screen bg-[#08080a]">
      <BrowserRouter>
        <AdsProvider>
          <SmoothScroll />
          <AgeGate />
          <AppRouter />
        </AdsProvider>
        <Toaster theme="dark" position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
